import React, { Component } from "react"
import AccordionWithLink from "./accordion-with-link-component"
import ReactHtmlParser from "react-html-parser"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"

export default class AccordionAndTextContainer extends Component {
  render() {
    const topPadding = SelectionFactoryHelper.getFromSelectionFactory(this.props.topPadding)
    return (
      <div className={`flightinfo-accordion ${topPadding ? topPadding : ""}`}>
        <div className="w--normal">
          <div className="infotext">
            <h4>{this.props.heading}</h4>
            <div className="maintext">{ReactHtmlParser(this.props.text)}</div>
          </div>
          {this.props.contentArea && this.props.contentArea.length > 0
            ? this.props.contentArea.map((item, index) => {
                return <AccordionWithLink key={index} {...item} />
              })
            : ""}
        </div>
      </div>
    )
  }
}
